import { Stack, Typography } from "@mui/material"

type ConfirmationRowProps = Readonly<{
    label: string
    value?: string
}>

export function ConfirmationRow({ label, value }: ConfirmationRowProps) {
    return (
        <Stack direction="row" justifyContent="space-between" gap="0.5rem">
            <Typography variant="body1" color="text.secondary">
                {label}
            </Typography>
            <Typography variant="body1">{value || "-"}</Typography>
        </Stack>
    )
}

